import React from 'react'
import { Menu } from "antd"
import { useNavigate } from 'react-router-dom'
function BottomBar({ active }) {
    const navigate = useNavigate()
    const items = [
        {
            label: "Home",
            key: 22,
            onClick: () => navigate('/')
        },
        {
            label: "About",
            key: 23,
            onClick: () => navigate('/about')
        },
        {
            label: "Portfolio",
            key: 24,
            onClick: () => navigate('/portfolio')
        },
        {
            label: "Get a Word",
            key: 26,
            onClick: () => navigate('/contact')
        },
    ]
    return (
        <Menu
            theme='dark'
            mode="vertical"
            defaultSelectedKeys={['6']}
            className={`NavBarMedia ${active && 'active'}`}
            disabledOverflow={true}
            items={items}
            style={{ paddingLeft: "20px" }}
        />
    )
}

export default BottomBar